//src/utils/freeShippingDiscount.js
export const buildFreeShippingInfo = ({
  discount,
  subtotal = 0,
  totalItems = 0,
  lang = "EN",
}) => {
  if (!discount) {
    return {
      hasDiscount: false,
      valid: false,
      minRequirement: "none",
      label: "",
      conditionLabel: "",
      endLabel: "",
    };
  }

  const subtotalValue = Number(subtotal || 0);
  const itemsCount = Number(totalItems || 0);

  const minRequirement = discount.min_requirement || "none";
  const minAmount = Number(discount.min_amount || 0);
  const minQty = Number(discount.min_qty || 0);

  let valid = false;
  let label = "";
  let conditionLabel = "";

  if (minRequirement === "none") {
    valid = true;

    label =
      lang === "AR"
        ? "شحن مجاني على جميع الطلبات"
        : "Free delivery on all orders";

    conditionLabel =
      lang === "AR"
        ? "على جميع الطلبات"
        : "All orders";
  }

  if (minRequirement === "amount") {
    valid = subtotalValue >= minAmount;

    const missingAmount = Math.max(0, minAmount - subtotalValue);

    label = valid
      ? lang === "AR"
        ? `تم تفعيل الشحن المجاني لأن طلبك وصل إلى $${minAmount}`
        : `Free delivery unlocked on orders over $${minAmount}`
      : lang === "AR"
      ? `أضيفي $${missingAmount.toFixed(2)} للحصول على شحن مجاني`
      : `Add $${missingAmount.toFixed(2)} more for free delivery`;

    conditionLabel =
      lang === "AR"
        ? `للطلبات فوق $${minAmount}`
        : `Orders over $${minAmount}`;
  }

  if (minRequirement === "qty") {
    valid = itemsCount >= minQty;

    const missingQty = Math.max(0, minQty - itemsCount);

    label = valid
      ? lang === "AR"
        ? `تم تفعيل الشحن المجاني عند شراء ${minQty}+ منتجات`
        : `Free delivery unlocked for ${minQty}+ items`
      : lang === "AR"
      ? `أضيفي ${missingQty} منتجات للحصول على شحن مجاني`
      : `Add ${missingQty} more item${missingQty === 1 ? "" : "s"} for free delivery`;

    conditionLabel =
      lang === "AR"
        ? `${minQty}+ منتجات`
        : `${minQty}+ items`;
  }

  const endLabel = discount.end_at
    ? new Date(discount.end_at).toLocaleString(
        lang === "AR" ? "ar" : "en",
        {
          day: "numeric",
          month: "short",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit",
        }
      )
    : "";

  return {
    hasDiscount: true,
    valid,
    minRequirement,
    minAmount,
    minQty,
    label,
    conditionLabel,
    endLabel,
  };
};